var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarIcon04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.63645 8.99967L0.666748 11.333V0.999674C0.666748 0.631488 0.965228 0.333008 1.33341 0.333008H11.3334C11.7016 0.333008 12.0001 0.631488 12.0001 0.999674V8.99967H3.63645ZM3.17529 7.66634H10.6667V1.66634H2.00008V8.58974L3.17529 7.66634ZM5.33342 10.333H12.1582L13.3334 11.2564V4.33301H14.0001C14.3683 4.33301 14.6667 4.63149 14.6667 4.99967V13.9997L11.6971 11.6663H6.00008C5.6319 11.6663 5.33342 11.3679 5.33342 10.9997V10.333Z",
    fill: "#6B7385"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIcon04);
export default __webpack_public_path__ + "static/media/sidebar-icon-04.e0c406a213658ac40038121add0d75e8.svg";
export { ForwardRef as ReactComponent };